import http from "./httpClient.js";

// Public dance directory (no login required): /api/v1/public

export async function getGenres() {
    const response = await http.get(`/public/genres`);
    return response.data;
}

/**
 * @param {{ genres?: string, day?: string, from?: string, to?: string, level?: string,
 *           maxPrice?: number, city?: string, near?: string, radiusKm?: number }} params
 */
export async function getSchools(params = {}) {
    const response = await http.get(`/public/schools`, { params });
    return response.data;
}

export async function getSchool(schoolId) {
    const response = await http.get(`/public/schools/${schoolId}`);
    return response.data;
}

export async function getClasses(params = {}) {
    const response = await http.get(`/public/classes`, { params });
    return response.data;
}

export async function getEvents(params = {}) {
    const response = await http.get(`/public/events`, { params });
    return response.data;
}

/** @param {string} [date] YYYY-MM-DD: a specific date of a repeating event */
export async function getEvent(eventId, date) {
    const response = await http.get(`/public/events/${eventId}`, { params: date ? { date } : {} });
    return response.data;
}

export async function getOrganizer(organizerId) {
    const response = await http.get(`/public/organizers/${organizerId}`);
    return response.data;
}

export async function reportOutdatedInfo(data) {
    const response = await http.post(`/public/reports`, data);
    return response.data;
}

/**
 * Anonymous click tracking. Uses fetch with keepalive (instead of the shared
 * axios client) so it survives navigating away to WhatsApp/Maps and never
 * shows an error notification to the visitor.
 */
export function trackInteraction(data) {
    try {
        fetch(`${process.env.VUE_APP_API_URL}/public/track`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
            keepalive: true,
        }).catch(() => {});
    } catch {
        // tracking must never break the page
    }
}
